/**
 * Contact requests (F7).
 *
 * @see docs/plan/IMPLEMENTATION_PLAN.md task 7.5, PRD §5.7, §5.9
 */
import type {
  ContactDetail,
  ContactSummary,
  CreateContactRequest,
  ListContactsQuery,
  UpdateContactRequest,
} from '@nexus/contracts';

import { api } from '../../../lib/api-client';
import type { PageMeta } from '../../../lib/pagination';

/** A page of contacts. */
export interface ContactPage {
  data: ContactSummary[];
  meta: PageMeta;
}

export async function listContacts(query: ListContactsQuery): Promise<ContactPage> {
  return api.get<ContactPage>('/contacts', { query });
}

export async function getContact(id: string): Promise<ContactDetail> {
  return api.get<ContactDetail>(`/contacts/${id}`);
}

export async function createContact(body: CreateContactRequest): Promise<ContactDetail> {
  return api.post<ContactDetail>('/contacts', body);
}

export async function updateContact(
  id: string,
  body: UpdateContactRequest,
): Promise<ContactDetail> {
  return api.patch<ContactDetail>(`/contacts/${id}`, body);
}
